<template>
  <section>
    <div
      class="bg-green-dark text-white text-sm w-max px-3 py-1 flex rounded-lg"
    >
      <p>{{ data.option }}</p>
      <button
        type="button"
        class="ml-1 font-semibold text-lg"
        @click="handleClearFilterValue(data.key, data.option, data.type)"
      >
        <X />
      </button>
    </div>
  </section>
</template>

<script>
import { X } from "@/components/icons";
export default {
  name: "Chip",
  components: { X },
  props: {
    data: Object,
    handleClearFilterValue: Function,
  },
};
</script>
